import { createSelector } from 'reselect'
import featureScopesSelector from "./featureScopesSelector"

const isComparisonButtonVisibleSelector = createSelector(
    featureScopesSelector,
    (featureScopes): boolean => featureScopes.includes('compass'),
)

export default isComparisonButtonVisibleSelector
